<template>
    <Section class="wrong-route">
        <SectionHeader
            :title="$t('wrong-route.header.title')"
            :image="require('@/assets/v3/img/tool-box.png')"
        />
    </Section>
</template>

<i18n>
{
    "en": {
        "wrong-route": {
            "header": {
                "title": "Oops, looks like this page does not exist"
            }
        }
    },
    "es": {
        "wrong-route": {
            "header": {
                "title": "Oops, parece que esta página no existe"
            }
        }
    },
    "fr": {
        "wrong-route": {
            "header": {
                "title": "Oups, il semble que cette page n'existe pas"
            }
        }
    },
    "pt": {
        "wrong-route": {
            "header": {
                "title": "Oops, parece que esta página não existe"
            }
        }
    },
    "de": {
        "wrong-route": {
            "header": {
                "title": "Ups, es sieht so aus, als würde diese Seite nicht existieren"
            }
        }
    },
    "nl": {
        "wrong-route": {
            "header": {
                "title": "Oeps, het lijkt erop dat deze pagina niet bestaat"
            }
        }
    }
}
</i18n>

<script>
import Section from '@/components/v3/section/Section.vue'
import SectionHeader from '@/components/v3/section/SectionHeader.vue'
import SideBarButton from './SideBarButton.vue'
import EmptyButton from '@/components/v3/buttons/EmptyButton.vue'
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'

export default {
    components: {
        Section,
        SectionHeader,
        SideBarButton,
        EmptyButton
    },
    data() {
        return {
        }
    },
    computed: {
        organizationName() {
            const configStore = getModule(ConfigStore)
            return configStore.userOrganization.fullName
        },
        organizationLogoUrl() {
            const configStore = getModule(ConfigStore)
            return this.$processUrl(configStore.userOrganization.logoUrl)
        }
    },
    methods: {
        gotoCampaigns() {
            // this.$goto
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.wrong-route
    nada

</style>



// WEBPACK FOOTER //
// src/modules/app/components/WrongRoute.vue